<template>
  <div class="container">
    <div class="toolbar">
      <div class="left-items">
        <a-button class="item" icon="icon icon-home" @click="on_reset" />

        <a-button class="item" icon="icon icon-reset" @click="load()" />

        <a-button class="item" icon="replay" v-if="$route.query.in_search" primary @click="on_load" />

        <a-button
          class="item"
          icon="icon icon-jiarucopy"
          @click="on_create()"
          type="primary"
          v-if="permissible.indexOf('member.create') > -1"
        />

        <a-button class="item" ref="replay" icon="replay" v-if="$route.query.in_search" primary @click="on_load" />
        <a-button
          class="item"
          ref="delete"
          type="danger"
          icon="delete"
          secondary
          @click="on_delete(selected_row_keys)"
          :disabled="!selected_row_keys.length"
          v-if="permissible.indexOf('member.delete') > -1"
        />

        <a-divider type="vertical" class="item" />

        <a-popover
          v-if="basic_data_user.length"
          title="选择销售"
          :getPopupContainer="(trigger) => trigger.parentNode"
          style="width:120px;"
        >
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px;">
              <a-checkable-tag
                  style="cursor:pointer"
                class="r-checkbox checkbox-tag"
                v-for="item in basic_data_user"
                :key="item.id"
                :checked="search_user_ids.some((v) => v == item.id)"
                @change="(e) => on_mutli_field(e, item.id, 'search_user_ids')"
              >{{ item.name }}
              </a-checkable-tag
              >
            </div>
            <a-button
              type="primary"
              size="small"
              @click="on_mutli_search('search_user_ids', 'sale_id')"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('sale_id')">清除搜索</a-button>
          </template>
          <a-button
            v-if="basic_data_user.length"
            class="item slice"
            :ghost="!!search_user_ids.length"
            :type="!!search_user_ids.length ? 'primary' : 'default'"
          >
            选择销售
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="客户等级" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px">
              <a-checkable-tag
                class="r-checkbox checkbox-tag"
                v-for="item in level_array"
                :key="item.value"
                :checked="search_level.some((v) => v == item.value)"
                @change="(e) => on_mutli_field(e, item.value, 'search_level')"
              >{{ item.value }}
              </a-checkable-tag
              >
            </div>

            <a-button type="primary" size="small" @click="on_mutli_search('search_level', 'level')"
                      style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('level')">清除搜索</a-button>
          </template>
          <a-button class="item slice" :ghost="!!search_level.length"
                    :type="!!search_level.length ? 'primary' : 'default'">
            客户等级
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="客户身份" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px">
              <a-checkable-tag
                  style="cursor: pointer"
                class="r-checkbox checkbox-tag"
                :checked="search_identity.some((v) => v == '1')"
                @change="(e) => on_mutli_field(e, '1', 'search_identity')"
              >直客
              </a-checkable-tag
              >
              <a-checkable-tag
                  style="cursor: pointer"
                  class="r-checkbox checkbox-tag"
                :checked="search_identity.some((v) => v == '2')"
                @change="(e) => on_mutli_field(e, '2', 'search_identity')"
              >渠道
              </a-checkable-tag
              >
              <a-checkable-tag
                  style="cursor: pointer"
                  class="r-checkbox checkbox-tag"
                :checked="search_identity.some((v) => v == '3')"
                @change="(e) => on_mutli_field(e, '3', 'search_identity')"
              >代理商
              </a-checkable-tag
              >
            </div>

            <a-button
              type="primary"
              size="small"
              @click="on_mutli_search('search_identity', 'taxonomy')"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('taxonomy')">清除搜索</a-button>
          </template>
          <a-button class="item slice" :ghost="!!search_identity.length"
                    :type="!!search_identity.length ? 'primary' : 'default'">
            客户身份
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="客户需求" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px">
              <a-checkable-tag
                class="r-checkbox checkbox-tag"
                v-for="item in demand_type_array"
                :key="item.value"
                :checked="search_demand_type.some((v) => v == item.value)"
                @change="(e) => on_mutli_field(e, item.value, 'search_demand_type')"
              >{{ item.name }}
              </a-checkable-tag
              >
            </div>

            <a-button
              type="primary"
              size="small"
              @click="on_mutli_search('search_demand_type', 'demand_type')"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('demand_type')">清除搜索</a-button>
          </template>
          <a-button
            class="item slice"
            :ghost="!!search_demand_type.length"
            :type="!!search_demand_type.length ? 'primary' : 'default'"
          >
            客户需求
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="来源渠道" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content" v-if="basic_data_source.length">
            <div style="max-width:480px;margin-bottom:12px">
              <a-card
                  class="project"
                  size="small"
              >
                <a-checkable-tag
                    class="r-checkbox checkbox-tag"
                    v-for="(i,idx) in basic_data_source[0]['children']" :key="idx"
                    :checked="search_source_id === i.id"
                    @change="search_source_id = i.id"
                >{{ i.title }}
                </a-checkable-tag>
              </a-card>
<!--              <a-card
                class="project"
                :title="basic_data_source[0].title"
                size="small"
              >
                <a-checkable-tag
                  class="r-checkbox checkbox-tag"
                  v-for="(i,idx) in basic_data_source[0]['children']" :key="idx"
                  :checked="search_source_id === i.id"
                  @change="search_source_id = i.id"
                >{{ i.title }}
                </a-checkable-tag>
              </a-card>-->

<!--              <a-card
                class="project"
                :title="basic_data_source[1].title"
                size="small"
              >
                <a-checkable-tag
                  class="r-checkbox checkbox-tag"
                  v-for="(i,idx) in basic_data_source[1]['children']"
                  :key="idx"
                  :checked="search_promote_source_id === i.id"
                  @change="search_promote_source_id = i.id"
                >{{ i.title }}
                </a-checkable-tag>
              </a-card>-->
            </div>

            <a-button
              type="primary"
              size="small"
              @click="on_source_search"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_source_reset">清除搜索</a-button>
          </template>
          <a-button
            class="item slice"
            :ghost="!!search_demand_type.length"
            :type="!!search_demand_type.length ? 'primary' : 'default'"
          >
            来源渠道
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="客户属性" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px">
              <a-checkable-tag
                class="r-checkbox checkbox-tag"
                v-for="item in member_type_array"
                :key="item.value"
                :checked="search_member_type === item.value"
                @change="search_member_type = item.value"
              >{{ item.name }}
              </a-checkable-tag
              >
            </div>

            <a-button
              type="primary"
              size="small"
              @click="on_mutli_search('search_member_type', 'member_type')"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('member_type')">清除搜索</a-button>
          </template>
          <a-button
            class="item slice"
            :ghost="!!search_demand_type.length"
            :type="!!search_demand_type.length ? 'primary' : 'default'"
          >
            客户属性
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-popover title="商标需求" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
          <template slot="content">
            <div style="max-width:480px;margin-bottom:12px">
              <a-checkable-tag
                v-for="(item, index) in trademark_array"
                :key="index"
                class="r-checkbox checkbox-tag"
                :value="JSON.stringify(item)"
                :checked="search_trademark_types.some((v) => v == item.value)"
                @change="(e) => on_mutli_field(e, item.value, 'search_trademark_types')"
              ><strong>{{ item.value }}</strong> {{ item.name }}
              </a-checkable-tag
              >
            </div>

            <a-button
              type="primary"
              size="small"
              @click="on_mutli_search('search_trademark_types', 'trademark_types')"
              style="margin-right:12px"
            >搜索
            </a-button
            >
            <a-button size="small" @click="on_reset_field('trademark_types')">清除搜索</a-button>
          </template>
          <a-button
            class="item slice"
            :ghost="!!search_demand_type.length"
            :type="!!search_demand_type.length ? 'primary' : 'default'"
          >
            商标需求
            <a-icon type="caret-down" />
          </a-button>
        </a-popover>

        <a-divider type="vertical" class="item" />

        <a-dropdown ref="moreButton" class="item">
          <a-menu slot="overlay">
            <a-menu-item @click="on_move_tags(selected_rows)" :disabled="!selected_row_keys.length">编辑标签</a-menu-item>
            <a-menu-item
              v-if="permissible.indexOf('member.distribute') > -1"
              @click="on_distribute(selected_rows)"
              :disabled="!selected_row_keys.length"
            >更改销售
            </a-menu-item
            >
          </a-menu>
          <a-button icon="icon icon-caozuo"></a-button>
        </a-dropdown>

        <template v-if="selected_row_keys.length">
          <a-divider type="vertical" class="item" />

          <span class="item selected">
                        已选中：
                        <span class="num">{{ selected_row_keys.length }}</span
                        >条
                    </span>
        </template>
      </div>

      <div class="right-items">
        <a-input-search placeholder="搜索姓名、手机号码" enter-button @search="on_search" class="item" v-model="wd" />
        <a-button class="item" @click="on_adsearch" icon="icon icon-gaojisousuo1"
                  :type="visible_search ? 'primary' : ''" />

        <a-dropdown-button @click="on_dir_change" class="item">
          {{ sort_field_text }}
          <a-menu slot="overlay">
            <template v-for="item in sort_field_columns">
              <a-menu-item v-if="sort_field != item.value" :key="item.value" @click="on_sort_change(item.value)">{{
                  item.name
                }}
              </a-menu-item>
            </template>
          </a-menu>

          <a-icon :type="sort_dir === 'asc' ? 'sort-ascending' : 'sort-descending'" slot="icon" />
        </a-dropdown-button>

        <a-button @click="visible_export=true" icon="export">
          导出
        </a-button>

      </div>
    </div>

    <!-- 主体表格 -->
    <div class="main">
      <!-- 高级搜索 -->
      <advance_search :visible="visible_search" @close="visible_search = false" @load="load" :callback="load"
                      :path="path" />

      <a-tabs v-model="level" @change="(e) => on_field_change(e, 'level')">
        <a-tab-pane tab="客户列表" key=""></a-tab-pane>
        <a-tab-pane key="reminder_today">
          <span slot="tab"><a-icon type="calendar" theme="twoTone" two-tone-color="#52c41a" /> 今日待跟进</span>
        </a-tab-pane>
        <a-tab-pane key="reminder_overdue">
          <span slot="tab"><a-icon type="alert" theme="twoTone" two-tone-color="#eb2f96" /> 过期未跟进</span>
        </a-tab-pane>
        <a-tab-pane v-for="l in level_array"
                    :key="l.value.toString()">
          <template #tab>
            <div>
              <!--{{l.value == 0 ? `新客户` : `L${l.value}`}}-->
              <div v-if="l.value == 0">新客户</div>
              <a-tooltip v-else :mouseEnterDelay="0" :mouseLeaveDelay="0">
                <template slot="title">
                  {{ l.name }}
                </template>
                <span style="padding: 5px 10px;">{{ `L${l.value}` }}</span>
              </a-tooltip>
            </div>
          </template>

        </a-tab-pane>
      </a-tabs>

      <a-table
        :columns="columns"
        :dataSource="data_source"
        rowKey="id"
        :loading="loading"
        :pagination="pagination"
        :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
        :custom-row="custom_row"
        size="middle"
        :scroll="{ x: true }"
        @change="(e) => on_pagination_change(e, path)"
      >
        <template slot="recharge_expense" slot-scope="text, record">
          <table class="b-table">
            <tbody>
            <tr>
              <td width="40">询价</td>
              <td style="color: #2a90ff;cursor:pointer" @click="on_enquiry(record)">{{ record.enquiry_count }}次</td>
            </tr>
            <tr>
              <td>成交</td>
              <td style="color: #2a90ff;cursor:pointer" @click="on_order(record)">{{ record.order_count }}次</td>
            </tr>
<!--            <tr>
              <td>消费</td>
              <td>{{ record.recharge_total || "" }}</td>
            </tr>-->
            </tbody>
          </table>
        </template>

        <template slot="id" slot-scope="text, record">
          <div class="ida">
            <div class="id">
              <a-dropdown>
                                <span class="ant-dropdown-link pointer" @click="(e) => e.preventDefault()">
                                    {{ record.id }} <a-icon type="down" />
                                </span>

                <a-menu slot="overlay">
                  <a-menu-item key="edit" @click="on_show(record)">
                    <a-icon type="ellipsis" />
                    详情
                  </a-menu-item>
                  <a-menu-divider />
                  <a-menu-item @click="on_move_tags([record])">
                    <a-icon type="tags" />
                    编辑标签
                  </a-menu-item>

                  <a-menu-item key="reset_password" @click="on_reset_password(record)"
                  >
                    <a-icon type="icon icon-mima"></a-icon>
                    修改登录密码
                  </a-menu-item
                  >

                  <a-menu-item
                    v-if="permissible.indexOf('member.distribute') > -1"
                    key="distribute"
                    @click="on_distribute([record])"
                  >
                    <a-icon type="user" />
                    更改销售
                  </a-menu-item
                  >
                  <a-menu-divider />
                  <a-menu-item @click="redirect(`/order/whole?member_id=${record.id}`)"
                  >
                    <a-icon type="icon icon-link1"></a-icon>
                    <span>查看他的订单</span>
                  </a-menu-item>
                  <a-menu-item @click="redirect(`/finance/transaction?member_id=${record.id}`)"
                  >
                    <a-icon type="icon icon-link1"></a-icon>
                    <span>查看他的交易流水</span></a-menu-item
                  >
                  <a-menu-item @click="redirect(`/resource/whole?member_id=${record.id}`)"
                  >
                    <a-icon type="icon icon-link1"></a-icon>
                    <span>查看他的店铺</span></a-menu-item
                  >
                  <a-menu-item @click="redirect(`/contract?member_id=${record.id}`)"
                  >
                    <a-icon type="icon icon-link1"></a-icon>
                    <span>查看他的合同</span></a-menu-item
                  >

                  <a-menu-divider />

                  <a-menu-item @click="on_login_user(record)">
                    <a-icon type="mobile" />
                    登录到用户端
                  </a-menu-item>

                  <template v-if="permissible.indexOf('member.delete') > -1">
                    <a-menu-divider />
                    <a-menu-item key="disabled" @click="on_disabled(record)"
                    >
                      <a-icon type="stop" />
                      禁用（禁止使用平台）
                    </a-menu-item
                    >

                    <a-menu-item key="delete" @click="on_delete(record)">
                      <a-icon type="delete" />
                      删除
                    </a-menu-item>
                  </template>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </template>

        <template slot="remark" slot-scope="text">
          <div class="remark">{{ text }}</div>
        </template>

        <!-- 等级 -->
        <template slot="name" slot-scope="text, record">
          <div class="member-name">
            <div class="name">
              <a-badge :status="record.login_status == 1 ? 'success' : 'default'" />
              {{ record.name || "匿名" }}
              <a-icon
                v-if="record.verified_at"
                :class="record.verified_type"
                class="verified"
                type="icon icon-renzheng"
              ></a-icon>
            </div>
            <div class="id">
              <a-tag class="level" :color="level_array[level_array.findIndex((v) => v.value == record.level)]['color']"
              >L{{ record.level }}
              </a-tag
              >
              ID:{{ record.id }}
            </div>
          </div>
        </template>

        <!-- 客户信息   -->
        <template slot="info" slot-scope="text, record">
          <div class="member-company">
            <ul>
              <li v-if="record.taxonomy">
                <div class="icon">
                  <a-icon type="icon icon-ziliaofuzhi" />
                </div>
                <div class="text">
                  {{ record.taxonomy_text }}
                </div>
              </li>
              <li v-if="record.com_name">
                <div class="icon">
                  <a-icon type="icon icon-gongsi" />
                </div>
                <div class="text">
                  <a
                    :href="'https://www.qcc.com/search?key=' + record.com_name"
                    target="_blank"
                    v-if="record.com_name.length > 5"
                  >{{ record.com_name }}</a
                  >
                  <template v-else>
                    {{ record.com_name }}
                  </template>
                </div>
              </li>
              <li v-if="record.resource_count">
                <div class="icon">
                  <a-icon type="icon icon-shop" />
                </div>
                <div class="text">
                  <router-link :to="`/resource/search?member_id=${record.id}`" target="_blank"
                  >{{ record.resource_count }}个店铺
                  </router-link>
                </div>
              </li>
              <li>
                <div class="icon">
                  <a-icon type="tag" />
                </div>
                <div class="text">{{ record.demand_type_text }}</div>
              </li>
            </ul>
          </div>
        </template>

        <!-- 联系方式 -->
        <template slot="contact" slot-scope="text, record">
          <table class="contact b-table">
            <tbody>
            <tr>
              <td style="text-align:left" width="20">
                <i class="anticon anticon-icon icon-phone"></i>
              </td>
              <td @click="do_copy(record.mobile)" class="copy">{{ record.mobile }}</td>
            </tr>
            <tr v-if="record.qq">
              <td style="text-align:left">
                <a-icon type="icon icon-qq1"></a-icon>
              </td>
              <td class="copy" @click="do_copy(record.qq)">{{ record.qq }}</td>
            </tr>
            <tr v-if="record.wechat_id">
              <td style="text-align:left">
                <i class="anticon anticon-icon icon-we-chat-s"></i>
              </td>
              <td class="copy" @click="do_copy(record.wechat_id)">{{ record.wechat_id }}</td>
            </tr>
            </tbody>
          </table>
        </template>

        <!-- 跟进动态 -->
        <template slot="revisit" slot-scope="text, record">
          <revisit-render :member="record" :record="text" :count="record.revisit_count" :callback="load" />
        </template>

        <!-- 跟进人信息 -->
        <template slot="user" slot-scope="text">
          <div class="tbox" v-if="text">
            <div class="a">
              <a-badge :status="text.login_status == 1 ? 'success' : 'default'" />
              {{ text.name || "匿名" }}
            </div>
            <div class="b" v-if="text.group">{{ text.group.name }}</div>
          </div>
        </template>

        <!-- 注册信息 -->
        <template slot="registered" slot-scope="text, record">
          <table class="registered b-table">
            <tbody>
            <tr>
              <td style="width:35px">时间</td>
              <td>
                <a-icon type="mobile" v-if="record.init_user_id == 0" style="color:#FF5722" />
                <span
                  v-html="$options.filters['friendly'](moment(record.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                ></span>
              </td>
            </tr>
            <tr>
              <td>最后</td>
              <td>
                                    <span
                                      v-html="
                                            record.last_login
                                                ? $options.filters['friendly'](
                                                      moment(record.last_login.created_at * 1000).format('YYYY-MM-DD HH:mm')
                                                  )
                                                : '-'
                                        "
                                    ></span>
              </td>
            </tr>
            <tr>
              <td>次数</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </template>

        <template slot="action" slot-scope="text, record">
          <a-dropdown-button @click="on_show(record)" size="small">
            <a-icon type="bars"></a-icon>
            <a-menu slot="overlay">
              <a-menu-item @click="on_move_tags([record])">
                <a-icon type="tags" />
                编辑标签
              </a-menu-item>

              <a-menu-item @click="on_reset_password(record)"
              >
                <a-icon type="icon icon-mima"></a-icon>
                修改登录密码
              </a-menu-item
              >

              <a-menu-item
                v-if="permissible.indexOf('member.distribute') > -1"
                key="distribute"
                @click="on_distribute([record])"
              >
                <a-icon type="user" />
                更改销售
              </a-menu-item
              >
              <a-menu-divider />
              <a-menu-item @click="redirect(`/order/whole?member_id=${record.id}`)"
              >
                <a-icon type="icon icon-link1"></a-icon>
                <span>查看他的订单</span>
              </a-menu-item>
              <a-menu-item @click="redirect(`/finance/transaction?member_id=${record.id}`)"
              >
                <a-icon type="icon icon-link1"></a-icon>
                <span>查看他的交易流水</span></a-menu-item
              >
              <a-menu-item @click="redirect(`/resource/whole?member_id=${record.id}`)"
              >
                <a-icon type="icon icon-link1"></a-icon>
                <span>查看他的店铺</span></a-menu-item
              >
              <a-menu-item @click="redirect(`/contract?member_id=${record.id}`)"
              >
                <a-icon type="icon icon-link1"></a-icon>
                <span>查看他的合同</span></a-menu-item
              >

              <a-menu-divider />

              <a-menu-item @click="on_login_user(record)">
                <a-icon type="mobile" />
                登录到用户端
              </a-menu-item>

              <template v-if="permissible.indexOf('member.delete') > -1">
                <a-menu-divider />
                <a-menu-item key="disabled" @click="on_disabled(record)"
                >
                  <a-icon type="stop" />
                  禁用（禁止使用平台）
                </a-menu-item
                >

                <a-menu-item key="delete" @click="on_delete(record)">
                  <a-icon type="delete" />
                  删除
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown-button>
        </template>
      </a-table>
    </div>

    <!-- 跟进动态 -->
    <!-- <modal_followup :visible="visible_followup" @close="visible_followup = false" @load="load" :callback="load" /> -->

    <!-- 修改密码 -->
    <modal_resetpwd :visible="visible_resetpwd" @close="visible_resetpwd = false" :record="selected_record" />

    <!-- 导出 -->
    <a-modal
      centered
      title="数据导出"
      :width="360"
      :visible="visible_export"
      :confirm-loading="exportting"
      @ok="on_export_submit"
      @cancel="visible_export = false"
    >
      <a-form-model>
        <a-form-model-item label="录入时间区间">
          <a-range-picker v-model="export_date" :disabledDate="(v) => v >= moment()" value-format="YYYY-MM-DD" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--        询价记录-->
    <a-modal :visible="visible_enquiry"
             @cancel="visible_enquiry = false"
             width="1000px"
             :footer="null"
             title="询价记录">
      <template>
        <a-table :dataSource="modal_record.enquiry" :columns="columns_enquiry">
          <!-- 商标图片 -->
          <template slot="screenshot" slot-scope="text, record">
            <img :src="text" style="width: 120px">
          </template>
          <template slot="created_at" slot-scope="text, record">
            {{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}
          </template>
        </a-table>
      </template>
    </a-modal>

    <!--        成交记录-->
    <a-modal :visible="visible_order"
             @cancel="visible_order = false"
             width="1000px"
             :footer="null"
             title="成交记录">
      <template>
        <a-table :dataSource="modal_record.order" :columns="columns_order">
          <!-- 商标图片 -->
          <template slot="screenshot" slot-scope="text, record">
            <img :src="text" style="width: 120px">
          </template>
          <template slot="created_at" slot-scope="text, record">
            {{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}
          </template>
          <template slot="updated_at" slot-scope="text, record">
            {{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}
          </template>
        </a-table>
      </template>
    </a-modal>

  </div>
</template>

<script>
import advance_search from "../components/advance_search.vue";
import modal_followup from "../components/modal_followup.vue";
import modal_resetpwd from "../components/modal_resetpwd";
import common_pagination from "../../../mixins/common_pagination.js";
import basic_data from "../../../mixins/basic_data";

import moment from "moment";
import commonjs from "../mixins/common";

export default {
  mixins: [common_pagination, commonjs, basic_data],
  components: {
    advance_search,
    modal_followup,
    modal_resetpwd
  },
  data() {
    return {
      sub_title: "客户列表",
      path: "/member/whole",
      loading: false,
      data_source: [],
      trigger: null,
      move_ids: [],
      begin_at: +new Date(),
      wd: null,
      // visible_followup: false,
      visible_create: false,
      visible_search: false,
      visible_resetpwd: false,
      visible_show: false,
      visible_enquiry: false,
      visible_order: false,
      selected_record: null,
      modal_record:{
        enquiry:null,
        order:null,
      },
      level: "",
      columns_enquiry: [
        {
          title: '商标图片',
          dataIndex: 'trademark.logo',
          key: 'trademark.logo',
          scopedSlots: {
            customRender: "screenshot",
          },
        },
        {
          title: '名称',
          dataIndex: 'trademark.markName',
          key: 'trademark.markName',
        },
        {
          title: '类别',
          dataIndex: 'trademark.type_text',
          key: 'trademark.type_text',
        },
        {
          title: '商标号',
          dataIndex: 'trademark.applyNo',
          key: 'trademark.applyNo',
        },
        {
          title: '报价',
          dataIndex: 'sell_price',
          key: 'sell_price',
        },
        {
          title: '询价备注',
          dataIndex: 'remark',
          key: 'remark',
        },
        {
          title: '询价时间',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: "created_at",
          },
        },
      ],
      columns_order: [
        {
          title: '商标图片',
          dataIndex: 'trademark.logo',
          key: 'trademark.logo',
          scopedSlots: {
            customRender: "screenshot",
          },
        },
        {
          title: '名称',
          dataIndex: 'trademark.markName',
          key: 'trademark.markName',
        },
        {
          title: '类别',
          dataIndex: 'trademark.type_text',
          key: 'trademark.type_text',
        },
        {
          title: '商标号',
          dataIndex: 'trademark.applyNo',
          key: 'trademark.applyNo',
        },
        {
          title: '报价',
          dataIndex: 'sell_price',
          key: 'sell_price',
        },
        {
          title: '成交价格',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '订单备注',
          dataIndex: 'remark',
          key: 'remark',
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: {
            customRender: "created_at",
          },
        },
        {
          title: '成交时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
          scopedSlots: {
            customRender: "updated_at",
          },
        },
      ],
      columns: [
        {
          dataIndex: "name",
          title: "姓名以及编号",
          width: 140,
          scopedSlots: {
            customRender: "name"
          }
        },
        {
          dataIndex: "info",
          title: "需求",
          scopedSlots: {
            customRender: "info"
          },
          width: 160
        },
        {
          dataIndex: "contact",
          title: "联系方式",
          width: 130,
          scopedSlots: {
            customRender: "contact"
          }
        },
        {
          dataIndex: "recharge_expense",
          title: "交易动态",
          width: 120,
          scopedSlots: {
            customRender: "recharge_expense"
          }
        },
        {
          dataIndex: "last_revisit",
          title: "跟进动态",
          width: 340,
          scopedSlots: {
            customRender: "revisit"
          }
        },
        {
          dataIndex: "registered",
          title: "注册信息",
          width: 160,
          scopedSlots: {
            customRender: "registered"
          }
        },
        {
          dataIndex: "user",
          title: "跟进人",
          width: 100,
          scopedSlots: {
            customRender: "user"
          }
        },
        {
          dataIndex: "remark",
          title: "备注",
          scopedSlots: {
            customRender: "remark"
          }
        },
        {
          dataIndex: "action",
          title: "操作",
          width: 75,
          align: "center",
          scopedSlots: {
            customRender: "action"
          }
        }
      ]
    };
  },
  watch: {
    $route() {
      this.reset_query();
      this.selected_row_keys = [];
      this.load();
    }
  },
  created() {
    this.reset_query();
    this.load();

    this.$store.commit("change_state", {
      name: "member_sidebar_selected",
      value: "whole"
    });
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    }
  },
  methods: {
    moment,
    load() {
      this.loading = true;

      let new_query = JSON.parse(JSON.stringify(this.$route.query));
      this.$http
        .get(`/member/whole?${this.objectToQuery(new_query)}`)
        .then((res) => {
          if (res.success) {
            this.data_source = res.data;

            this.pagination = {
              pageSize: res.pagination.per_page,
              total: res.pagination.total,
              current: res.pagination.current_page
            };

            //每次加载完数据后再次统计
            this.load_stat();
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false;
        });
    },
    on_delete(record) {
      this.$confirm({
        centered: true,
        title: Array.isArray(record) ? "是否批量删除选中的客户？" : `是否要删除【${record.name}】？`,
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.$http
              .delete(`member/${Array.isArray(record) ? record.join(",") : record.id}`)
              .then((res) => {
                if (res.success) {
                  this.load();
                } else {
                  this.$error({
                    title: "失败",
                    centered: true,
                    content: res.message
                  });
                }
              })
              .catch(() => {
              })
              .then(() => {
                resolve();
              });
          });
        }
      });
    },
    on_adsearch() {
      this.visible_search = !this.visible_search;
    },
    //询价记录弹窗
    on_enquiry(record) {
      this.visible_enquiry = true;
      this.modal_record = record;
    },
    //订单记录弹窗
    on_order(record) {
      this.visible_order = true;
      this.modal_record = record;
    },
    on_reset_password(record) {
      this.visible_resetpwd = true;
      this.selected_record = record;
    },
    on_source_search() {
      if (this.search_source_id != null)
        this.on_mutli_search("search_source_id", "source_id");
      if (this.search_promote_source_id != null)
        this.on_mutli_search("search_promote_source_id", "promote_source_id");
    },
    on_source_reset() {
      if (this.search_source_id != null)
        this.on_reset_field("source_id");
      if (this.search_promote_source_id != null)
        this.on_reset_field("promote_source_id");
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}

.framework-container {
  .framework-body {
    position: absolute;
    left: 200px;
    right: 0;
    bottom: 0;
    top: 0;

    .main {
      overflow-y: auto;
      position: absolute;
      top: 57px;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .contact {
    width: 110px;
    font-size: 12px;
  }

  .user {
    .group {
      font-size: 12px;
      color: #00000080;
    }
  }

  .remark {
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }

  .member-name {
    .name {
      font-size: 13px;
      margin-bottom: 4px;
    }

    .id {
      font-size: 12px;

      .ant-tag {
        font-size: 12px;
        line-height: 18px;
        padding: 0 4px;
      }
    }
  }

  .member-company {
    ul {
      li {
        margin-bottom: 4px;
        font-size: 12px;
        display: flex;

        &:last-child {
          margin-bottom: 0;
        }

        .icon {
          width: 20px;

          .anticon {
            font-size: 14px;
          }
        }

        .text {
          width: 0;
          flex: 1;
        }
      }
    }
  }

  .ant-dropdown-menu-item {
    display: flex;
    align-items: center;
  }
}
</style>
